export type GroupType = 'family' | 'friends' | 'custom';

export interface GroupMembership {
  id: number;
  documentId: string;
  role: 'owner' | 'admin' | 'member';
  status: 'active' | 'pending';
  user?: { id: number; username: string; email?: string };
}

export interface GroupInvitation {
  id: number;
  documentId: string;
  inviteeEmail: string;
  status: 'pending' | 'accepted' | 'declined' | 'expired';
  createdAt: string;
  expiresAt?: string;
}

export interface Group {
  id: number;
  documentId: string;
  name: string;
  type: GroupType;
  description?: string | null;
  owner?: { id: number; username: string };
  memberships?: GroupMembership[];
  invitations?: GroupInvitation[];
  /** Injected by /groups/mine - the caller's own role in this group */
  myRole?: 'owner' | 'admin' | 'member';
  createdAt: string;
  updatedAt: string;
}

export const GROUP_TYPE_LABELS: Record<GroupType, string> = {
  family: 'familie',
  friends: 'venner',
  custom: 'andet',
};

export const GROUP_TYPE_ICONS: Record<GroupType, string> = {
  family: 'ti-home-heart',
  friends: 'ti-users',
  custom: 'ti-star',
};
